import { render, staticRenderFns } from "./Medidas.vue?vue&type=template&id=532b4c6b&scoped=true"
import script from "./Medidas.vue?vue&type=script&lang=js"
export * from "./Medidas.vue?vue&type=script&lang=js"
import style0 from "./Medidas.vue?vue&type=style&index=0&id=532b4c6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532b4c6b",
  null
  
)

export default component.exports